import React from "react";
import { Form } from "react-bootstrap";

const terminalOptions = [
  "",
  "BB",
  "BK",
  "BY",
  "CI",
  "CZ",
  "GD",
  "GW",
  "JG",
  "KD",
  "KI",
  "KL",
  "KN",
  "KO",
  "KR",
  "KZ",
  "LD",
  "LG",
  "LO",
  "LU",
  "NS",
  "NT",
  "OL",
  "OP",
  "P2",
  "PD",
  "PI",
  "PL",
  "PO",
  "PT",
  "RA",
  "RZ",
  "SE",
  "SL",
  "SU",
  "SZ",
  "TA",
  "TG",
  "W2",
  "W3",
  "W7",
  "WA",
  "WB",
  "WD",
  "WL",
  "WR",
  "ZG",
];

const AddressesFillingHourlyIntervalsFilters = ({ onFilterChange, onSearch, filters = {} }) => {
  return (
    <div className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <div className="d-flex gap-4">
          <Form.Group controlId="mode" style={{ minWidth: "180px" }}>
            <Form.Label className="fw-bold">EX/DR</Form.Label>
            <Form.Control
              as="select"
              value={filters.mode || "EX"}
              onChange={(e) => onFilterChange("mode", e.target.value)}
            >
              <option value="EX">EX</option>
              <option value="DR">DR</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="terminal" style={{ minWidth: "180px" }}>
            <Form.Label className="fw-bold">Terminal</Form.Label>
            <Form.Control
              as="select"
              value={filters.terminal || ""}
              onChange={(e) => onFilterChange("terminal", e.target.value)}
            >
              {terminalOptions.map((option) => (
                <option key={option || "empty"} value={option}>
                  {option}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>
      </Form>
    </div>
  );
};

export default AddressesFillingHourlyIntervalsFilters;

